import { EntityType } from './entity-type';
import { StringFilter } from './string-filter';

export class NameEntityTypeFilter {
  name?: StringFilter;
  entityTypeArea?: EntityType;
}
